export default __webpack_public_path__ + "static/media/banner-1.83005fc3.jpeg";